module.exports = __webpack_public_path__ + "img/health-guide-vaccination.ba0ebfb8.png";